import { createRouter, createWebHistory } from 'vue-router'
import IndexComponent from '../components/IndexComponent.vue'
import LoginComponent from '../components/LoginComponent.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: IndexComponent,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginComponent
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn')
  
  if (to.meta.requiresAuth && !isLoggedIn) {
    next('/login')
  } else {
    next()
  }
})

export default router 